// 生产绩效使用独立接口和数据表，不与储运绩效共享业务接口。
export default {
  // 月度台账独立增删改查，不提交或关联单条生产绩效ID。
  monthlyList: '/ygsjzs/scMonthlyPerformance/list',
  monthlyAdd: '/ygsjzs/scMonthlyPerformance/add',
  monthlyUpdate: '/ygsjzs/scMonthlyPerformance/update',
  monthlyDelete: '/ygsjzs/scMonthlyPerformance/delete',
  monthlySaveExtra: '/ygsjzs/scMonthlyPerformance/saveExtra',
  selectByPage: '/ygsjzs/scPerformance/selectByPage',
  selectById: '/ygsjzs/scPerformance/selectById',
  selectSummary: '/ygsjzs/scPerformance/selectSummary',
  generate: '/ygsjzs/scPerformance/generate',
  // 两份模板分别导出，公共导出工具统一以 POST JSON 请求并按 Blob 下载。
  exportPerformancePdf: '/ygsjzs/scPerformance/exportPerformancePdf',
  exportPersonPerformancePdf: '/ygsjzs/scPerformance/exportPersonPerformancePdf',
  update: '/ygsjzs/scPerformance/update',
  delete: '/ygsjzs/scPerformance/delete',
  selectOrganizationUsers: '/ygsjzs/scPerformance/selectOrganizationUsers',
  saveAllocation: '/ygsjzs/scPerformance/saveAllocation'
}
